import React from 'react';
import { MapPin } from 'lucide-react';
import type { Service } from '../../types';
import ActionButtons from '../shared/ActionButtons';

interface LocationServiceHeroProps {
  city: string;
  state: string;
  service: Service | null;
  title?: string;
}

export default function LocationServiceHero({ city, state, service, title }: LocationServiceHeroProps) {
  return (
    <div className="relative bg-blue-600">
      <div className="max-w-7xl mx-auto py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="flex items-center justify-center text-blue-200 mb-4">
            <MapPin className="h-5 w-5 mr-2 flex-shrink-0" />
            <span className="truncate">{city ? `${city}, ${state}` : state}</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white tracking-tight mb-4">
            AC, Refrigerator, TV, Microwave, Washing Machine Service Center
            <span className="block text-2xl mt-2 text-blue-100">
              in {city ? `${city}, ${state}` : state}
            </span>
          </h1>
          
          <p className="mt-4 max-w-2xl mx-auto text-base sm:text-lg text-blue-100">
            Professional repair services with expert technicians, same-day service, and 90-day warranty
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <ActionButtons />
          </div>
        </div>
      </div>
    </div>
  );
}